import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Course } from '../models/course';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';
import { Quiz } from '../models/quiz';

@Injectable({
  providedIn: 'root'
})

export class CourseService {

    constructor(private http: HttpClient) {
    }

    public updateCourse(course:Course, supporters:any, tutors:any, categories:any, tags:any, roles:any){
      return this.http.put(environment.apiEndpoint + '/api/admin/course', {course:course, supporters:supporters, tutors:tutors, categories:categories, tags:tags, roles:roles}).pipe(
        map(
          res => {
            return res;
          }
        )
      );
    }

    public refreshCourseImage(courseId:number):Observable<any>{
      return this.http.get(environment.apiEndpoint+'/api/admin/course/'+courseId+'/refreshImage').pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getDocuments(courseId:number):Observable<any>{
      return this.http.get(environment.apiEndpoint+'/api/course/documents/'+courseId).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public uploadDocument(fname:string, ftype:string, fb64:string, courseId:number):Observable<any>{
      return this.http.post(environment.apiEndpoint+'/api/admin/course/'+courseId+'/document', {fname:fname, ftype:ftype, fb64:fb64}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public deleteDocument(docId:number, courseId:number):Observable<any>{
      return this.http.delete(environment.apiEndpoint+`/api/admin/course/${courseId}/document/${docId}`).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getCourses(page,pp,sorts,filters, includes): Observable<iHttpPaginatedResponse>{
        return this.http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/course?page=${page}&pp=${pp}&sort=${sorts}&${filters}&${includes}`).pipe(
            map(res => {
                return res
            })
        );
    }

    public getActiveCourses(): Observable<any>{
      return this.http.get(environment.apiEndpoint+'/api/courses/active').pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getQuiz(quizId:number): Observable<Quiz>{
        return this.http.get<Quiz>(environment.apiEndpoint + `/api/course/quiz/${quizId}`).pipe(
            map(res => {
                return new Quiz(res);
            })
        );
    }

    public updateFeaturedCourses(updates:any): Observable<any>{
      return this.http.put(environment.apiEndpoint+'/api/admin/courses/featured', {updates:updates}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public getCourse(course_id, admin=false): Observable<Course> {
      let params='';
      if(admin) params='?admin=true';
        return this.http.get<Course>(environment.apiEndpoint + `/api/course/${course_id}${params}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public createCourse() {
      return this.http.post(environment.apiEndpoint + '/api/admin/course', {courseId:0}).pipe(
        map(
          res => {
            return res;
          }
        )
      );
    }
}